import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

import { getAdminRefunds, createRefund } from "../../api/adminApi";

export default function AdminRefunds() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [open, setOpen] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getAdminRefunds();
      setItems(res.data?.items || []);
    } catch (e) {
    console.error(e);
    const msg =
      e?.response?.data?.error ||
      e?.response?.data?.message ||
      `Failed to load refunds (HTTP ${e?.response?.status || "?"})`;
    setError(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

 const handleCreate = async () => {
  setError("");

  const orderIdNum = Number(orderId);
  const paymentIdNum = paymentId ? Number(paymentId) : null;
  const amountNum = Number(amount);

  if (!Number.isFinite(orderIdNum)) {
    setError("Order ID must be a number.");
    return;
  }

  if (paymentId && !Number.isFinite(paymentIdNum)) {
    setError("Payment ID must be a number (or leave it empty).");
    return;
  }

  if (!Number.isFinite(amountNum) || amountNum <= 0) {
    setError("Amount must be a valid number greater than 0.");
    return;
  }

  try {
    await createRefund({
      orderId: orderIdNum,
      paymentId: paymentIdNum,
      amount: amountNum,
      reason: reason || "",
    });

    setOpen(false);
    setOrderId("");
    setPaymentId("");
    setAmount("");
    setReason("");
    await load();
  } catch (e) {
    console.error(e);
    const msg =
      e?.response?.data?.error ||
      e?.response?.data?.message ||
      `Failed to create refund (HTTP ${e?.response?.status || "?"})`;
    setError(msg);
  }
};


  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        Refunds
      </Typography>
      <Typography sx={{ mb: 2, color: "text.secondary" }}>
        Manual refund record tool (long-term safe).
      </Typography>

      <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
        <Button variant="contained" onClick={() => setOpen(true)}>
          Create Refund
        </Button>
        <Button variant="outlined" onClick={load} disabled={loading}>
          Refresh
        </Button>
        {loading && <Typography sx={{ color: "text.secondary" }}>Loading…</Typography>}
        {error && <Typography sx={{ color: "error.main" }}>{error}</Typography>}
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Order</TableCell>
              <TableCell>Payment</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Method</TableCell>
              <TableCell>External Ref</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{r.id}</TableCell>
                <TableCell>{r.order_id}</TableCell>
                <TableCell>{r.payment_id || "-"}</TableCell>
                <TableCell>{r.amount}</TableCell>
                <TableCell>{r.reason || "-"}</TableCell>
                <TableCell>{r.method || "-"}</TableCell>
                <TableCell>{r.external_ref || "-"}</TableCell>
                <TableCell>{r.created_at ? new Date(r.created_at).toLocaleString() : "-"}</TableCell>
              </TableRow>
            ))}

            {!items.length && !loading && (
              <TableRow>
                <TableCell colSpan={8} sx={{ color: "text.secondary" }}>
                  No refunds found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create Refund</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
  label="Order ID"
  type="number"
  value={orderId}
  onChange={(e) => setOrderId(e.target.value)}
/>

<TextField
  label="Payment ID (optional)"
  type="number"
  value={paymentId}
  onChange={(e) => setPaymentId(e.target.value)}
/>

<TextField
  label="Amount"
  type="number"
  inputProps={{ step: "0.01" }}
  value={amount}
  onChange={(e) => setAmount(e.target.value)}
/>

<TextField
  label="Reason (optional)"
  value={reason}
  onChange={(e) => setReason(e.target.value)}
/>

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleCreate}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
